import type { ReactNode } from 'react';

import { Typography } from '@mui/material';

type NodeTitleProps = {
  text: ReactNode;
  italic?: boolean;
};

export const NodeTitle = ({ text, italic = false }: NodeTitleProps) => (
  <Typography
    variant='body2'
    noWrap
    sx={{
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: 'text.primary',
      ...(italic ? { fontStyle: 'italic' } : {})
    }}
  >
    {text}
  </Typography>
);
